'use strict'
/**
 * primeScore.js — Contrato PrimeScore (MACRO 1 · Ola 2).
 *
 * "Prime Score es vector, no escalar" (regla doctrinal #9): el esquema
 * exige el vector por dominio, no solo el global.
 *
 * PRODUCTOR: src/engine/primeScoreCalculator.js
 * CONSUMIDOR: PROGRESS (prime_score_history), DOMINIOS (limiting_domain),
 *             TODAY (coherencia A3 limiting_domain)
 */

const { z } = require('./z')

const Confidence = z.enum(['high', 'medium', 'low'])

const PrimeScoreSchema = z
  .object({
    score_global: z.number().min(0).max(10),
    // El vector: un score por dominio (clave = domainId)
    scores_by_domain: z.record(z.string(), z.number().min(0).max(10)),
    limiting_domain: z.string().nullable(),
    limiting_domain_score: z.number().nullable().optional(),
    phenotype: z.string().optional().nullable(),
    weights_applied: z.record(z.string(), z.number()).optional(),
    audit_sources: z.unknown().optional(),
    calculated_at: z.string().optional(),
    confidence: Confidence,
  })
  .passthrough()

module.exports = { PrimeScoreSchema }
